// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FR5E","content":"styles_content__1U_AG","row":"styles_row__3ns7O","footer":"styles_footer__2bXiF","phraseLength":"styles_phraseLength__1maj_"};